import { render, staticRenderFns } from "./ModalLicenseOption.vue?vue&type=template&id=8b6716f6&scoped=true&"
import script from "./ModalLicenseOption.vue?vue&type=script&lang=ts&"
export * from "./ModalLicenseOption.vue?vue&type=script&lang=ts&"
import style0 from "./ModalLicenseOption.vue?vue&type=style&index=0&id=8b6716f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6716f6",
  null
  
)

export default component.exports